import { Dispatch } from 'redux'

import { create, update, destroy } from 'redux/api/EconomyAccounts'

import { toggleSnackbarOpen } from 'redux/actions/Snackbar'
import { useThunkActions } from 'redux/actions/useThunkActions'

import { SnackbarMessage } from 'types/GlobalSnackbar'

import * as actions from './actions'

function tryCreateEconomyAccount(
  data: { name: string; number: string; economy_set_id: string },
  callback?: (err?: boolean) => void
) {
  return (dispatch: Dispatch) => {
    dispatch(actions.create())

    create(data)
      .then((response) => {
        dispatch(
          actions.createSuccess({
            data: response.data.data,
            economySetId: data.economy_set_id
          })
        )

        dispatch(toggleSnackbarOpen(SnackbarMessage.ChartOfAccountsUpdated))

        if (callback) {
          callback()
        }
      })
      .catch(() => {
        dispatch(actions.createFailed())

        dispatch(
          toggleSnackbarOpen(SnackbarMessage.ChartOfAccountsUpdatedFailed)
        )

        if (callback) {
          callback(true)
        }
      })
  }
}

function tryUpdateEconomyAccount(
  id: string,
  name: string,
  economySetId: string,
  callback?: (err?: boolean) => void
) {
  return (dispatch: Dispatch) => {
    dispatch(actions.update())

    update(id, name)
      .then((response) => {
        dispatch(
          actions.updateSuccess({ data: response.data.data, economySetId })
        )

        dispatch(toggleSnackbarOpen(SnackbarMessage.ChartOfAccountsUpdated))

        if (callback) {
          callback()
        }
      })
      .catch(() => {
        dispatch(actions.updateFailed())

        dispatch(
          toggleSnackbarOpen(SnackbarMessage.ChartOfAccountsUpdatedFailed)
        )

        if (callback) {
          callback(true)
        }
      })
  }
}

function tryDeleteEconomyAccount(
  id: string,
  economySetId: string,
  callback?: (err?: boolean) => void
) {
  return (dispatch: Dispatch) => {
    dispatch(actions.destroy())

    destroy(id)
      .then(() => {
        dispatch(actions.destroySuccess({ id, economySetId }))

        dispatch(toggleSnackbarOpen(SnackbarMessage.ChartOfAccountsUpdated))

        if (callback) {
          callback()
        }
      })
      .catch(() => {
        dispatch(actions.destroyFailed())

        dispatch(
          toggleSnackbarOpen(SnackbarMessage.ChartOfAccountsUpdatedFailed)
        )

        if (callback) {
          callback(true)
        }
      })
  }
}

export const useEconomyAccountActions = () => {
  return {
    tryCreateEconomyAccount: useThunkActions(tryCreateEconomyAccount),
    tryDeleteEconomyAccount: useThunkActions(tryDeleteEconomyAccount),
    tryUpdateEconomyAccount: useThunkActions(tryUpdateEconomyAccount)
  }
}
